import axios from 'axios';
import store from '../store';
function addTokenToConfig(config) {
    if (store.getters.IsAuthenticated) {
        const token = store.getters.GetToken;
        if (token && config.headers) {
            config.headers['x-Token'] = token;
            config.headers['Authorization'] = `IQ.APIv1 ${token}`;
        }
    }
    return config;
}
export default function setup() {
    axios.interceptors.request.use(function (config) {
        return addTokenToConfig(config);
    }, (error) => error);
    axios.interceptors.response.use((response) => response, async (error) => {
        const originalRequest = error.config;
        //Old webservice version returns 419 for bad/expired token
        if (error.response && (error.response.status === 401 || error.response.status == 419) && !originalRequest._neverRetry) {
            originalRequest._neverRetry = true;
            await store.dispatch('refreshToken');
            if (store.getters.IsAuthenticated) {
                addTokenToConfig(originalRequest);
                return axios.request(originalRequest);
            }
            else {
                store.dispatch('logout');
                return Promise.resolve(error);
            }
        }
        if (error.response?.data) {
            store.commit('setWebserviceError', error.response.data);
        }
        else {
            store.commit('setWebserviceError', { Message: error.message, Error: error.message });
        }
        if (error.response)
            store.commit('setWebserviceStatusCode', error.response.status);
        return Promise.resolve(error);
    });
}
